import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Theme = 'light' | 'dark'
export type AppLocale = 'ar' | 'en'

interface AppState {
  theme: Theme
  locale: AppLocale
  setTheme: (t: Theme) => void
  toggleTheme: () => void
  setLocale: (l: AppLocale) => void
  toggleLocale: () => void
}

/**
 * Global theme + locale store, persisted to localStorage. Lives in its
 * own module (not `theme-provider.tsx`) so the provider file only
 * exports a component — keeps React Fast Refresh working.
 */
export const useAppStore = create<AppState>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      locale: 'ar',
      setTheme: (theme) => set({ theme }),
      toggleTheme: () => set({ theme: get().theme === 'dark' ? 'light' : 'dark' }),
      setLocale: (locale) => set({ locale }),
      toggleLocale: () => set({ locale: get().locale === 'ar' ? 'en' : 'ar' }),
    }),
    {
      name: 'abdallah-app',
      partialize: (s) => ({ theme: s.theme, locale: s.locale }),
    },
  ),
)
